import { FileDto, UserProfileDto, UserRole } from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_FILES } from "../domain";

import { filesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_FILE = "GET_FILE";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

export const getFile = async (fileId: string): Promise<FileDto> => {
  const response = await filesApi.filesControllerGetFile(fileId);

  return response.data;
};

export const useGetFile = (
  user: UserProfileDto | null,
  fileId: string,
): {
  file: FileDto | undefined;
  getFileEnabled: boolean;
  getFileError: Error | null;
  refetchGetFile: () => void;
  isLoadinGetFile: boolean;
  isFetchingGetFile: boolean;
  isSuccessGetFile: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryResult = useQuery<FileDto, Error>({
    queryKey: [DOMAIN_FILES, ACTION_GET_FILE, fileId],
    queryFn: () => getFile(fileId),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    file: queryResult.data,
    getFileEnabled: enabled,
    getFileError: queryResult.error,
    refetchGetFile: queryResult.refetch,
    isLoadinGetFile: queryResult.isLoading,
    isFetchingGetFile: queryResult.isFetching,
    isSuccessGetFile: queryResult.isSuccess,
  };
};
